/*********** Reduceres defined here *********/

import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage'; // default: localStorage if web, AsyncStorage if react-native
import encryptor from './encryptor';
import { user } from './user';
import { treatment } from './treatment';
import { document } from './document';
import { navigationReducer } from './navigationReducer';
import { navigationReducer2 } from './navigationReducer2';
import { tagPanelReducer } from './tagPanelReducer';
import { chatPanelReducer } from './chatPanelReducer';
import { queue } from './queue';
import { dashboard } from './dashboard';
import { general } from './general';
import { documentLabelPanelReducer } from './documentLabelPanelReducer';
import { fileSetting } from './fileSetting';
import { tagSearchReducer } from './tagSearchReducer';
import { tempReducer } from './tempReducer';
import { incomeAnalyzer } from './incomeAnalyzer';
import { assetAnalyzer } from './assetAnalyzer';
import localforage from "localforage"


// const userPersistConfig = {
// 	key: 'front-end-app',
// 	// key: "document",
// 	storage: storage,
// 	transforms: [encryptor],
// 	blacklist: ['router', 'loader']
// };

const userPersistConfig = {
	key : "root",
	storage: localforage
} // new indexed storage instead of local storage


export default persistCombineReducers(userPersistConfig, {
	user,
	treatment,
	document,
	navigationReducer,
	navigationReducer2,
	chatPanelReducer,
	general,
	queue,
	tagPanelReducer,
	dashboard,
	documentLabelPanelReducer,
	fileSetting,
	tagSearchReducer,
	tempReducer,
	incomeAnalyzer,
	assetAnalyzer
});
